import Keycloak from "keycloak-js";
import {KEYCLOAK_CONFIG} from "./jsx/shared/constants";
const keycloak = new Keycloak(KEYCLOAK_CONFIG);
export default keycloak;
